<template>
  <div class="overlay"
        v-show="action.pending || action.failed"
        :style="{backgroundColor}">
    <v-layout
      column
      justify-center
      align-center
      v-show="action.pending"
      class="overlay__content"
      :style="{ maxHeight: contentHeight }"
      >
      <v-flex shrink grow>
        <v-progress-circular indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-layout
      column
      justify-center
      align-center
      v-show="action.failed"
      class="overlay__content"
      :style="{ maxHeight: contentHeight }"
      >
      <v-flex shrink grow>
        <slot name="on-error">
          <span>
            {{appConstant.DEFAULT_LOADING_ERROR_MESSAGE}}
          </span>
        </slot>
      </v-flex>
      <v-flex shrink grow v-show="retryable">
        <v-btn flat @click="action.retry()">Retry</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { colorConstant } from '../../common/styles/colors.constant';
import { appConstant } from '../../app.constant';
import { VProgressCircular } from 'vuetify/es5/components/VProgressCircular';

export default {
  name: 'StatusOverlay',
  data() {
    return {
      appConstant,
    };
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
    backgroundColor: {
      type: String,
      default: colorConstant().white,
    },
    contentHeight: {
      type: String,
      default: 'auto',
    },
    retryable: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VProgressCircular,
  },
};
</script>

<style lang="scss" scoped>
 @import "../../common/styles/_colors.scss";

.overlay__content {
  height: 100%;
}
</style>
